import { apiUrls } from '../../utils/api/api-urls';
import REQUEST from '../../utils/services';

export const SHOPIFY_SALES_CHANNEL_ALL_SUCCESS = 'SHOPIFY_SALES_CHANNEL_ALL_SUCCESS';
export const SHOPIFY_SALES_CHANNEL_ALL_LOADING = 'SHOPIFY_SALES_CHANNEL_ALL_LOADING';

const { ShopifySalesByChannelAll: { getShopifySalesByChannelAll } } = apiUrls;


export const getShopifySalesByChannelAllDetails = () => async (dispatch) => {
  try {    
    const data = await REQUEST(getShopifySalesByChannelAll);
    dispatch({
      type: SHOPIFY_SALES_CHANNEL_ALL_SUCCESS,
      data,
    })
  } catch (e) {

    dispatch({
      type: SHOPIFY_SALES_CHANNEL_ALL_SUCCESS,
      data: {
        code: "",
        modal: null,
        notifications: null,
        paginationInfo: null
      }
    })
  }

}

export const handleAllLoader = isAllLoading => (dispatch) => {
  dispatch({
    type: SHOPIFY_SALES_CHANNEL_ALL_LOADING,
    isAllLoading
  })
}
